import * as KronicleAuth from "@kronicle/auth";

export const KronicleAuthProvider = KronicleAuth.AccountProvider;
export const useKronicleAuth = KronicleAuth.useOAuthSSO;
export const useKronicleAccount = KronicleAuth.useAccount;
export const LoginCallBackPage = KronicleAuth.LoginCallBackPage;
export const ExternalRedirectAuthLogin = KronicleAuth.ExternalRedirectAuthLogin;
export const getRedirectOnExternalProductWithLoginUrl = KronicleAuth.getRedirectOnExternalProductWithLoginUrl;
